<adapt-activity-section-collapsible [section]="section"
                                    [count]="displayedCount"
                                    [totalCount]="activityGroup.totalCount"
                                    [countTooltip]="countTooltip"
                                    [fallbackText]="fallbackText"
                                    [isLoading]="isLoading"
                                    [error]="error">
    <div class="d-flex flex-row flex-wrap gap-3 dashboard-meetings-wrapper">
        @if (ongoingMeetings && ongoingMeetings.length > 0) {
            <adapt-universal-dashboard-element name="In progress"
                                               [background]="false"
                                               [nested]="true">
                <div class="dashboard-meetings">
                    @for (group of ongoingMeetings; track group) {
                        <div>
                            <adapt-link-team-meetings-page *adaptIfAlto="false"
                                                           [team]="group.team"
                                                           class="d-block mb-1"></adapt-link-team-meetings-page>
                            <div class="d-flex flex-column gap-3">
                                @for (meeting of group.meetings; track meeting) {
                                    <adapt-meeting-dashboard-card [meeting]="meeting"
                                                                  [showTeamName]="false"
                                                                  [compact]="false"></adapt-meeting-dashboard-card>
                                }
                            </div>
                        </div>
                    }
                </div>
            </adapt-universal-dashboard-element>
        }

        @if (upcomingMeetings && upcomingMeetings.length > 0) {
            <adapt-universal-dashboard-element name="Upcoming"
                                               [background]="false"
                                               [nested]="true">
                <div class="dashboard-meetings">
                    @for (group of upcomingMeetings; track group) {
                        <div>
                            <adapt-link-team-meetings-page *adaptIfAlto="false"
                                                           [team]="group.team"
                                                           class="d-block mb-1"></adapt-link-team-meetings-page>
                            <div class="d-flex flex-column gap-3">
                                @for (meeting of group.meetings; track meeting) {
                                    <adapt-meeting-dashboard-card [meeting]="meeting"
                                                                  [showTeamName]="false"
                                                                  [compact]="false"></adapt-meeting-dashboard-card>
                                }
                            </div>
                        </div>
                    }
                </div>
            </adapt-universal-dashboard-element>
        }

        @if (upcomingMeetingsPastScheduledDate && upcomingMeetingsPastScheduledDate.length > 0) {
            <adapt-universal-dashboard-element name="Meetings past the scheduled date"
                                               [background]="false"
                                               [nested]="true">
                <div class="dashboard-meetings">
                    @for (group of upcomingMeetingsPastScheduledDate; track group) {
                        <div>
                            <adapt-link-team-meetings-page *adaptIfAlto="false"
                                                           [team]="group.team"
                                                           class="d-block mb-1"></adapt-link-team-meetings-page>
                            <div class="d-flex flex-column gap-3">
                                @for (meeting of group.meetings; track meeting) {
                                    <adapt-meeting-dashboard-card [meeting]="meeting"
                                                                  [showTeamName]="false"
                                                                  [compact]="false"></adapt-meeting-dashboard-card>
                                }
                            </div>
                        </div>
                    }
                </div>
            </adapt-universal-dashboard-element>
        }
    </div>
</adapt-activity-section-collapsible>
